import { useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import { myHrChangeRequestsEnabledState } from "my-hr/states/change-requests-enabled-state";

export const useMyHrChangeRequestsEnabled = () => {
  const state = useRecoilValue(myHrChangeRequestsEnabledState);
  const setState = useSetRecoilState(myHrChangeRequestsEnabledState);
  const resetState = useResetRecoilState(myHrChangeRequestsEnabledState);

  return { state, setState, resetState };
};

export default useMyHrChangeRequestsEnabled;
